module.exports = __webpack_public_path__ + "static/media/firebase.196eae76.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/firebase.png
 ** module id = 218
 ** module chunks = 0
 **/